module.exports = __webpack_public_path__ + "img/CockUp.ff2a36f3.png";